<template>
  <div>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="12">
        <label>{{ tarefa }}</label>
      </SGPColComponent>
    </SGPRowComponent>
    <hr>
  </div>
</template>

<script>

export default {
  name: "TarefaConfiguradaComponent",

  props: {
    tarefa: {
      type: Object,
      required: false
    }
  },
}
</script>